// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"240":"support","538":"recovery","585":"migration","936":"registration","946":"news"}[chunkId] + "." + {"240":"2ca3dad8","538":"f398055e","585":"bd0830ed","936":"83b63461","946":"5dea8cc9"}[chunkId] + ".css";
};